import { defineFilters, stringList, text } from '@/components/kit/filters'

/**
 * What `/cases` actually accepts. Hidden cases are always included here — that is
 * what makes this the admin view — so there is no toggle for it.
 */
export const caseFilters = defineFilters(
    {
        search: text({ label: 'Search' }),
        categories: stringList({ label: 'Categories' })
    },
    { defaultLimit: 20 }
)

export type CaseSearch = ReturnType<typeof caseFilters.parse>
